/** @type {() => void} */
export function noop() {
  return undefined;
}